import React, { Component } from 'react';
import api from '../../services/api';
import './ListaAdiantamento.css';
import '../FormatNumero/FormatCurrency';
import currencyFormatter from '../FormatNumero/FormatCurrency';
import Menu from '../menu/Menu';
import Cookies from 'universal-cookie';

export default class Usuario extends Component {

    state = {
        _Usuario: [],
        ckCPF: '',
    }

    async componentDidMount() {
        const cookies = new Cookies();
        this.state.ckCPF = cookies.get('ckCPF')
        console.log(this.state.ckCPF)
        const response = await api.get(`/datasnap/rest/tsm/RecCorren("${this.state.ckCPF}","1")`);
        this.setState({ _Usuario: response.data.result[0] });
        console.log(response.data.result[0]);
    }


    render() {
        return (
            <div className="principal" >
                
                <div className="ListAdt">
                <Menu/>
                    <p></p>
                    <h2>Lista de Adiantamentos</h2>
                    <table className="table table-hover table-striped table-dark">
                        <thead>
                            <tr>
                                {/* {"RECNUM":"8227","CODFILIAL":"3","DTLANC":"26/11/2009","HISTORICO":"ADIANTAMENTO DE SALARIO","HISTORICO2":"Parcela: 1 / 1 :","DTVENC":"26/11/2009","NUMVALE":"1467","VALOR":"800","HISTORICO1":"ADIANTAMENTO DE SALARIO"}, */}
                                {/* <th scope="col">FILIAL</th> */}
                                <th scope="col">Dt. Lanc./Venc.</th>
                                <th scope="col">Históricos</th>
                                {/* <th scope="col">Dt. Venc.</th> */}
                                {/* <th scope="col">Nº Vale</th> */}
                                <th scope="col">Nº Vale / Valor R$</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state._Usuario.map(usuario => (
                                <tr key={usuario.RECNUM}>
                                    {/* <th scope="row">{usuario.DTLANC}</th> */}
                                    <td>{usuario.DTLANC} / {usuario.DTVENC}</td>
                                    <td><p>{usuario.HISTORICO}</p> <p>{usuario.HISTORICO2}</p>
                                        {usuario.HISTORICO1}
                                    </td>
                                    {/* <td>{usuario.DTVENC}</td> */}
                                    {/* <td>{usuario.NUMVALE}</td> */}
                                    <td>{usuario.NUMVALE} / {currencyFormatter(parseFloat(usuario.VALOR))}</td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}